import {
  Box,
  Link,
  // ListItem,
  Text,
  UnorderedList,
  Image,
  Button,
  BoxProps,
  // List,
} from "@chakra-ui/react";
import { CSSProperties } from "react";
import parse, {
  DOMNode,
  domToReact,
  attributesToProps,
} from "html-react-parser";
import React from "react";
import { nanoid } from "nanoid";
import { YoutubeIframePlayer } from "../news/components/YoutubeIframePlayer";

export interface HtmlParserProps {
  htmlString: string;
  onVideoFirstPlay?: (videoUrl: string) => void;
  dontStyle?: boolean;
}

export function HtmlParser({
  htmlString,
  onVideoFirstPlay,
  dontStyle,
  ...boxProps
}: HtmlParserProps & BoxProps) {
  const customRender = (node: DOMNode) => {
    if (node.type !== "tag") return;

    const { name, children, attribs } = node;
    const parsedChildren = children as DOMNode[];

    const props = attributesToProps(node.attribs);

    const style = props["style"];
    const align = props["align"] as CSSProperties["textAlign"];

    const customReactChildren = domToReact(parsedChildren, {
      replace: customRender,
      transform(reactNode, domNode) {
        if (domNode.type === "tag" && domNode.name === "iframe") {
          const { src } = domNode.attribs;
          return (
            <YoutubeIframePlayer key={src} onFirstPlay={onVideoFirstPlay}>
              {reactNode}
            </YoutubeIframePlayer>
          );
        }
        return <React.Fragment key={nanoid()}>{reactNode}</React.Fragment>;
      },
    });

    switch (name) {
      case "div":
        return (
          <Box layerStyle={attribs.layerstyle} sx={style} {...props}>
            {customReactChildren}
          </Box>
        );
      case "button":
        return (
          <Button
            variant={attribs.variant}
            layerStyle={attribs.layerstyle}
            size={attribs.size}
            sx={style}
            {...props}
          >
            {customReactChildren}
          </Button>
        );
      case "img":
        return (
          <Image
            layerStyle={attribs.layerstyle}
            src={attribs.src}
            sx={style}
            {...props}
          />
        );
      case "p":
        return (
          <Text
            style={
              dontStyle
                ? {}
                : {
                    fontSize: "lg",
                    lineHeight: "180%",
                    color: "dune.dune",
                    marginBottom: dontStyle ? 0 : 4,
                  }
            }
            variant={attribs.variant}
            sx={style}
            align={align}
            {...props}
          >
            {customReactChildren}
          </Text>
        );
      case "a":
        return (
          <Link
            color="blaze.400"
            href={attribs.href}
            layerStyle={attribs.layerstyle}
            isExternal
            sx={style}
            _hover={{
              color: "blaze.300",
            }}
            transition="all .2s linear"
            {...props}
          >
            {customReactChildren}
          </Link>
        );
      case "ul":
        return (
          <UnorderedList mb="32px" sx={style}>
            {customReactChildren}
          </UnorderedList>
        );
      // case "li":
      //   return (
      //     <List>
      //       <ListItem mb="4px" sx={style}>
      //         {customReactChildren}
      //       </ListItem>
      //     </List>
      //   );

      case "hr":
        return (
          <Box mb="32px" h="1px" w="full" background="transparent.white.10">
            {customReactChildren}
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Box {...boxProps}>{parse(htmlString, { replace: customRender })}</Box>
  );
}
